<template>

    <div class="trax-struct-map" v-show="loaded">
        <div :id="id+'-struct'" class="trax-struct-body">
            <div class="trax-block trax-level-1" v-for="section in sections" :key="section.id" :data-id="section.id"
                v-if="section.learning_units && section.learning_units.length > 0"
            >

                <h3 v-if="sections.length>1">{{ section.name }}</h3>

                <div class="clearfix"></div>

                <div :id="id+'-struct-'+section.id" class="trax-block-body" :data-id="section.id">

                    <enac-atpl-dashboard-phase-map-item v-for="learning_unit in section.learning_units" :key="learning_unit.id"
                        :id="id" :bus="bus" :item="learning_unit" :states="states" :individual="true"
                        v-if="programUnit(learning_unit)"
                    >
                    </enac-atpl-dashboard-phase-map-item>

                    <div class="trax-btn-square trax-icon" v-if="hasGroupUnits(section)">
                        + <i class="material-icons">people_outline</i>
                    </div>

                    <enac-atpl-dashboard-phase-map-item v-for="learning_unit in section.learning_units" :key="learning_unit.id"
                        :id="id" :bus="bus" :item="learning_unit" :states="states" :individual="true"
                        v-if="groupUnit(learning_unit)"
                    >
                    </enac-atpl-dashboard-phase-map-item>

                    <div class="trax-btn-square trax-icon" v-if="hasUserUnits(section)">
                        + <i class="material-icons">person_outline</i>
                    </div>

                    <enac-atpl-dashboard-phase-map-item v-for="learning_unit in section.learning_units" :key="learning_unit.id"
                        :id="id" :bus="bus" :item="learning_unit" :states="states" :individual="true"
                        v-if="userUnit(learning_unit)"
                    >
                    </enac-atpl-dashboard-phase-map-item>

                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
    export default {

        props: {
            id: null,
            bus: null
        },

        data: function() {
            return {
                lang: lang,
                loaded: false,
                endpoint: app_url+'polaris/api/front/dashboard/registrations/'+data.registration.id+'/phases/'+data.phase.id+'/learners/'+data.learner.id+'/with-program',
                sections: [],
                states : {},
            }
        },

        created: function() {
            this.getDataWithStates();
        },

        methods: {

            programUnit(learning_unit) {
                return !learning_unit.registration_id;
            },

            groupUnit(learning_unit) {
                return learning_unit.registration_id && !learning_unit.user_id;
            },

            userUnit(learning_unit) {
                return learning_unit.user_id;
            },

            hasGroupUnits(section) {
                for (var index in section.learning_units) {
                    var learning_unit = section.learning_units[index];
                    if (this.groupUnit(learning_unit)) return true;
                }
                return false;
            },

            hasUserUnits(section) {
                for (var index in section.learning_units) {
                    var learning_unit = section.learning_units[index];
                    if (this.userUnit(learning_unit)) return true;
                }
                return false;
            },

            getDataWithStates() {
                axios.get(this.endpoint)
                    .then(response => {
                        this.states = Array.isArray(response.data.data) ? {} : response.data.data
                        this.sections = response.data.included.sections;
                        this.loaded = true;
                    })
                    .catch(error => {
                    });
            },
        }
    }
</script>
